interface DispatchToastParams {
  content: string | undefined;
  type: 'error' | 'success' | 'warning';
  title?: string;
  description?: string;
}

export const dispatchToast = (detail: DispatchToastParams) => {
  dispatchEvent(new CustomEvent('showToast', { detail }));
};

export const dispatchToastErrorHandler = (statusCode: number) => {
  if (statusCode === 400) {
    dispatchToast({
      title: 'Aviso',
      content: 'Dados enviados estão mal formatados!',
      type: 'warning',
    });
    return;
  }
  if (statusCode === 404) {
    dispatchToast({
      title: 'Aviso',
      content: 'Empresa não foi encontrada!',
      type: 'warning',
    });
    return;
  }
  if (statusCode === 409) {
    dispatchToast({
      title: 'Aviso',
      content: 'Já foram cadastradas informações para essa empresa!',
      type: 'warning',
    });
    return;
  }
  if (statusCode === 413) {
    dispatchToast({
      title: 'Aviso',
      content: 'A soma dos arquivos enviados não deve ultrapassar 51MB',
      type: 'warning',
    });
    return;
  }
  if (statusCode >= 500) {
    dispatchToast({
      title: 'Erro',
      content: 'Houve um erro inesperado, contate o suporte!',
      type: 'error',
    });
    return;
  }
  dispatchToast({
    title: 'Erro',
    content: 'Houve um erro inesperado, contate o suporte!',
    type: 'error',
  });
  return;
};
